import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { OrcStatus } from 'src/app/models/orc-status';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { OrcStatusService } from 'src/app/services/orc-status.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { ContatoStatusService } from 'src/app/services/contato-status.service';
import { ContatoStatus } from 'src/app/models/contato-status';
import { ContatoService } from 'src/app/services/contato.service';

@Component({
  selector: 'app-selecionar-status-orcamento-modal',
  templateUrl: './selecionar-status-orcamento-modal.component.html',
  styleUrls: ['./selecionar-status-orcamento-modal.component.scss']
})
export class SelecionarStatusOrcamentoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  idCupom: any;
  idStatus: any;
  idGIContato;
  orcsStatus: OrcStatus[] = [];
  contatoStatus: ContatoStatus[] = [];
  carregando = true;
  tipo = 0;
  constructor(
    private orcStatusService: OrcStatusService,
    public dialogRef: MatDialogRef<SelecionarStatusOrcamentoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private pedidoService: PedidoService,
    private contatoStatusService: ContatoStatusService,
    private contatoService: ContatoService
  ) {
    if (data.idGIContato) {
      this.idGIContato = data.idGIContato;
    } else {
      this.idCupom = data.idCupom;
      this.idStatus = data.idStatus;
      if (data.tipo !== null && data.tipo !== undefined) {
        this.tipo = data.tipo;
      }
    }
  }

  ngOnInit(): void {
    if(this.idGIContato) {
      this.buscarContatoStatus();
    } else {
      this.buscarStatusOrcamento();
    }
  }

  selecionaStatus(idStatus) {
    if(this.idGIContato) {
      this.selecionaStatusContato(idStatus);
    } else {
      this.selecionaStatusOrcamento(idStatus);
    }
  }

  selecionaStatusContato(idStatus) {
    this.carregandoService.mostra('salvarStatusContato');
    this.carregando = true;
    this.contatoService.atualizarStatusDoContato(this.idGIContato, idStatus).subscribe((data: any) => {
      this.dialogRef.close(idStatus);
      this.carregando = false;
      this.carregandoService.esconde('salvarStatusContato');
    }, (erro) => {
      this.carregandoService.esconde('salvarStatusContato');
      this.notificacaoService.erro(erro);
    });
  }

  selecionaStatusOrcamento(idStatus) {
    this.carregandoService.mostra('salvarStatusOrcamento');
    this.carregando = true;
    this.pedidoService.atualizarStatusDoOrcamento(this.idCupom, idStatus, this.tipo).subscribe((data: any) => {
      this.dialogRef.close(idStatus);
      this.carregando = false;
      this.carregandoService.esconde('salvarStatusOrcamento');
    }, (erro) => {
      this.carregandoService.esconde('salvarStatusOrcamento');
      this.notificacaoService.erro(erro);
    });
  }

  buscarContatoStatus() {
    this.carregandoService.mostra('buscarContatoStatus');

    this.contatoStatusService.consultar().subscribe(
      (contatoStatus) => {
        this.contatoStatus = contatoStatus;

        this.carregandoService.esconde('buscarContatoStatus');
      },
      (erro) => {
        this.carregandoService.esconde('buscarContatoStatus');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarStatusOrcamento() {
    this.carregandoService.mostra('buscarStatusOrcamento');
    this.carregando = true;
    this.orcStatusService.consultar(this.tipo).subscribe((data: any) => {
      this.orcsStatus = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarStatusOrcamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarStatusOrcamento');
      this.notificacaoService.erro(erro);
    });
  }

}
